import { track } from '@eventbrite/datalayer-library';
import { CloseIcon } from '@eventbrite/marmalade';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export function customizeDrawerHeader(
    setIsDrawerOpen: (open: boolean) => void,
): void {
    const wrapper = document.querySelector('.ab-feed-buttons-wrapper');
    if (!wrapper || wrapper.querySelector('.header-title')) return;

    // Remove default refresh button
    const refreshBtn = wrapper.querySelector('.ab-refresh-button');
    if (refreshBtn) refreshBtn.remove();

    // Build custom header
    const headerContent = document.createElement('div');
    headerContent.className = 'custom-header-content';

    const titleDiv = document.createElement('div');
    titleDiv.className = 'header-title';
    titleDiv.textContent = 'Notifications';

    const descDiv = document.createElement('div');
    descDiv.className = 'header-description';
    descDiv.textContent = 'Stay up to date on important information';

    headerContent.appendChild(titleDiv);
    headerContent.appendChild(descDiv);

    // Replace default close icon
    const closeBtn = wrapper.querySelector('.ab-close-button');
    if (closeBtn) {
        const iconMarkup = renderToStaticMarkup(<CloseIcon />);
        closeBtn.innerHTML = iconMarkup;

        if (!(closeBtn as any).__clickHandlerAttached) {
            closeBtn.addEventListener('click', () => {
                setIsDrawerOpen(false);
                track({
                    eventName: 'NotificationDrawerCloseClicked',
                    eventData: {},
                });
            });
            (closeBtn as any).__clickHandlerAttached = true;
        }

        wrapper.insertBefore(headerContent, closeBtn);
    } else {
        wrapper.appendChild(headerContent);
    }
}
